import * as Sentry from "@sentry/browser";
import { ENV, ENVS } from "constant/app";
import get from "lodash/get";

function init() {
  if (ENV.NODE_ENV === ENVS.PRODUCTION) {
    Sentry.init({
      beforeSend: dropEvents,
      dsn: "https://aaf7563530db4a02a487c7557bf3bd60@sentry.io/1360410",
      environment: ENV.DEPLOY_TARGET,
      release: `ui@${ENV.COMMIT_VERSION}`,
    });

    Sentry.configureScope((scope) => {
      scope.setTag("app", ENV.APP_NAME);
    });
  }
}

function dropEvents(event) {
  const statusCode = get(event, "extra.Error.status");
  if ([401, 403].includes(statusCode)) {
    return null;
  }

  return event;
}

function setUser(user) {
  if (user) {
    Sentry.configureScope((scope) => {
      scope.setUser({
        id: user.id,
        email: user.email,
      });
      scope.setTag("accountId", user.account_id);
      scope.setTag("accountName", user.account.name);
    });
  } else {
    Sentry.configureScope((scope) => {
      scope.setUser(null);
      scope.setTag("accountId", null);
      scope.setTag("accountName", null);
    });
  }
}

/*
 * For manual messages, set the message context to include the stack
 * trace.
 */
function captureStack() {
  let stack;
  try {
    throw new Error("Capture Stack");
  } catch (error) {
    stack = error;
  }

  Sentry.configureScope((scope) => {
    scope.setExtra("stack", stack);
  });
}

export { captureStack, init, setUser };
